import {Injectable} from '@angular/core';
import {HttpService} from '@core/backend/common/api/http.service';
import {Observable} from 'rxjs';
import {GeospatialViewerConfiguration, GeospatialMetricsConfiguration} from '../model/viewer-config';
import {GeospatialFilterSettings} from '@core/interfaces/common/popout';
import {APIResponse, FilterFieldOption} from '@core/interfaces/system/system-common';
import {OutageFilterGroup} from './geospatial-viewer-controls.service';

@Injectable()
export class GeospatialViewerControlsApi {
    private prefix = 'geospatial';
    private prefixOutages = 'outage/spatial';
    private prefixFilter = 'popoutSettings';

    constructor(private api: HttpService) {}

    public getGeospatialViewerConfiguration(): Observable<GeospatialViewerConfiguration> {
        return this.api.get(`${this.prefix}/config`);
    }

    public getMetricConfig(workflowItemId: number): Observable<GeospatialMetricsConfiguration> {
        return this.api.get(`${this.prefix}/${workflowItemId}/metrics`);
    }

    public getGeospatialFilterSettings(): Observable<GeospatialFilterSettings> {
        return this.api.get(`${this.prefixFilter}/get/analyzer`);
    }

    public getFilterFieldOptions(
        workflowItemId: number,
        fieldKey: string,
        limit: number = 1000,
        search?: string,
        filters?: any[],
    ): Observable<APIResponse<FilterFieldOption[]>> {
        return this.api.post(`analyzer/${workflowItemId}/options/filters/field`, {
            fieldKey: fieldKey,
            searchString: search,
            filterParams: filters,
            maxItems: limit,
        });
    }

    public getFilterConfigForOutageLayer(): Observable<APIResponse<OutageFilterGroup[]>> {
        return this.api.get(`${this.prefixOutages}/filters`);
    }
}
